import type { LucideIcon } from 'lucide-react'
import { NavLink as ReactNavLink, Link as ReactLink, useNavigate } from 'react-router'
import classNames from 'classnames'

import useAuthStore from '@/stores/authStore'
import type { SVGIconProps } from '@/utils/types'

import './NavLink.scss'
interface NavLinkProps {
  to?: string
  text: string
  onClick?: () => void
  Icon?: LucideIcon | SVGIconProps
  isLogout?: boolean
  noPropagate?: boolean
}

function NavLink({
  to,
  text,
  onClick,
  Icon,
  isLogout,
  noPropagate
}: NavLinkProps) {
  const { logout } = useAuthStore()
  const navigate = useNavigate()

  const LinkComponent = isLogout ? ReactLink : ReactNavLink

  const handleClick = (e: React.MouseEvent) => {
    if (isLogout) {
      e.preventDefault()
      logout()
      navigate('/')
    } else if (noPropagate) {
      e.preventDefault()
      onClick?.()
    } else {
      onClick?.()
    }
  }

  return (
    <LinkComponent
      className={classNames('nav-link', { 'no-propagate': noPropagate })}
      to={to || '/'}
      onClick={handleClick}
    >
      {Icon && <Icon size={24} width={24} height={24} />}
      {text}
    </LinkComponent>
  )
}

export default NavLink
